import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import LogoBrand from '../LogoBrand';
import Navigation from '../Navigation';
import ProfileMenu from '../ProfileMenu';
import SearchBar from '../SearchBar';

import { ReactComponent as HelpIcon } from '../../../assets/images/icons/help-icon.svg';

const getPages = (allowedMovies, allowedShows) =>
  allowedShows || allowedMovies
    ? [
        {
          icon: 'user-clock',
          id: 'anticipation',
          label: 'Anticipation',
          isMenu: true,
          path: [
            ...(allowedShows
              ? [{ path: 'shows/anticipation-report', label: 'Shows' }]
              : []),
            ...(allowedMovies
              ? [{ path: 'movies/anticipation-report', label: 'Movies' }]
              : []),
            { path: 'report/anticipation-tracker', label: 'Tracker' }
            // { path: 'report/anticipation', label: 'All' }
          ]
        },
        {
          icon: 'tv',
          id: 'viewership',
          label: 'Viewership',
          path: 'attribution/platform'
        },
        {
          icon: 'sitemap',
          id: 'affinity',
          label: 'Affinity',
          path:
            allowedShows && allowedMovies
              ? 'affinity'
              : allowedShows
              ? 'shows/affinity'
              : allowedMovies
              ? 'movies/affinity'
              : ''
        },
        {
          icon: 'signal',
          id: 'rankings',
          label: 'Rankings',
          isMenu: true,
          path: [
            ...(allowedShows ? [{ path: 'shows', label: 'Shows' }] : []),
            ...(allowedMovies ? [{ path: 'movies', label: 'Movies' }] : []),
            ...(allowedShows ? [{ path: 'actors', label: 'Actors' }] : []),
            ...(allowedShows ? [{ path: 'networks', label: 'Networks' }] : []),
            ...(allowedShows ? [{ path: 'report/binge', label: 'Binge' }] : [])
          ]
        },
        {
          icon: 'paste',
          id: 'reports',
          label: 'Reports',
          isMenu: true,
          path: [
            { path: 'reports', label: 'My Reports' },
            { path: 'report-builder', label: 'Report Builder' }
          ]
        }
      ]
    : [];

const Header = ({ clientAvatar, onlyGEMReport, loggedIn, logout, user }) => {
  const allowedMovies = user.allowedPages.includes('/movies');
  const allowedShows = user.allowedPages.includes('/shows');
  return (
    <header
      className={classnames('tvt-header', {
        'tvt-header--logged-in': loggedIn,
        'tvt-header--gem-report': onlyGEMReport
      })}
    >
      <div className="tvt-header__top">
        <LogoBrand linkTo={onlyGEMReport ? '/gem-report' : '/'} />

        {loggedIn && !onlyGEMReport && <SearchBar />}

        {loggedIn && (
          <>
            <OverlayTrigger
              key="help"
              placement="bottom"
              overlay={<Tooltip id="tooltip-help">Help</Tooltip>}
            >
              <div className="tvt-header__help-icon">
                <a href="/help">
                  <HelpIcon className="tvt-header__help-icon-svg" />
                </a>
              </div>
            </OverlayTrigger>

            <ProfileMenu
              onLogout={logout}
              ogranizationName={user.organization}
            />
          </>
        )}
      </div>

      {loggedIn && !onlyGEMReport && (
        <Navigation routes={getPages(allowedMovies, allowedShows)} />
      )}
    </header>
  );
};

Header.propTypes = {
  clientAvatar: PropTypes.string,
  loggedIn: PropTypes.bool,
  logout: PropTypes.func,
  onlyGEMReport: PropTypes.bool,
  user: PropTypes.shape({
    allowedPages: PropTypes.arrayOf(PropTypes.string),
    allowedShows: PropTypes.bool,
    organization: PropTypes.string
  })
};

Header.defaultProps = {
  clientAvatar: '',
  loggedIn: false,
  logout: () => {},
  onlyGEMReport: true,
  user: {
    allowedPages: []
  }
};

export default Header;
